/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CreateHardwareItemMutationVariables = Types.Exact<{
  sku_code: Types.Scalars["String"];
  total_quantity: Types.Scalars["Float"];
  available_quantity: Types.Scalars["Float"];
  event_slug?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type CreateHardwareItemMutation = {
  createHardwareItem: Pick<
    Types.HardwareItem,
    "id" | "sku_code" | "total_quantity" | "available_quantity"
  >;
};

export const CreateHardwareItemDocument = gql`
  mutation CreateHardwareItem(
    $sku_code: String!
    $total_quantity: Float!
    $available_quantity: Float!
    $event_slug: String
  ) {
    createHardwareItem(
      sku_code: $sku_code
      total_quantity: $total_quantity
      available_quantity: $available_quantity
      event_slug: $event_slug
    ) {
      id
      sku_code
      total_quantity
      available_quantity
    }
  }
`;

/**
 * __useCreateHardwareItemMutation__
 *
 * To run a mutation, you first call `useCreateHardwareItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHardwareItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHardwareItemMutation, { data, loading, error }] = useCreateHardwareItemMutation({
 *   variables: {
 *      sku_code: // value for 'sku_code'
 *      total_quantity: // value for 'total_quantity'
 *      available_quantity: // value for 'available_quantity'
 *      event_slug: // value for 'event_slug'
 *   },
 * });
 */
export function useCreateHardwareItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateHardwareItemMutation,
    CreateHardwareItemMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateHardwareItemMutation,
    CreateHardwareItemMutationVariables
  >(CreateHardwareItemDocument, baseOptions);
}
export type CreateHardwareItemMutationHookResult = ReturnType<
  typeof useCreateHardwareItemMutation
>;
export type CreateHardwareItemMutationResult =
  ApolloReactCommon.MutationResult<CreateHardwareItemMutation>;
export type CreateHardwareItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateHardwareItemMutation,
    CreateHardwareItemMutationVariables
  >;
